import { Component, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import Swal from 'sweetalert2';


import { QuotationDeliverableForm } from '@teem/model-forms/quotation-deliverable-form';
import { QuotationDeliverable } from '@teem/models/quotation-deliverable';
import { SharedDataService } from '@teem/services/shared-data.service';
import { QuotationService } from '@teem/services/quotation.service';
import { QuotationForm } from '@teem/model-forms/quotation-form';
import { ACTIONS as QUOTE_ACTIONS } from '@teem/constants/quotes';
import { LoaderService } from '@teem/services/loader.service';
import { environment } from '@teem/environments/environment';
import { messages as i18n } from '@teem/constants/messages';
import { PLAN_TYPES } from '@teem/constants/subscription';
import { UserService } from '@teem/services/user.service';
import { client as ClientApi } from '@teem/constants/api';
import { Quotation } from '@teem/models/quotation';
import { parseDate } from '@teem/helpers/functions';
import { Client } from '@teem/models/client';

import { PaymentInfoModalComponent } from '@teem/quotes-module/modals/payment-info-modal/payment-info-modal.component';

@Component({
  selector: 'edit-quotation',
  templateUrl: './edit-quotation.component.html',
  styles: []
})
export class EditQuotationComponent implements OnInit {
  @Input('quotation') quotation: Quotation;
  @Output() onEdit: EventEmitter<any> = new EventEmitter();
  @Output() changeTab: EventEmitter<any> = new EventEmitter();
  quoteForm: FormGroup;
  deliverables: FormArray;
  deliverableForm: FormGroup;
  submitted: boolean = false;
  projectTypes: object[] = [
    { value: 'fixed', 'label': $localize`:@@ts.common.fixed:Fixed` },
    { value: 'hourly', 'label': $localize`:@@ts.common.fixed:Hourly` },
  ];
  defaultPaymentInfo: any = {};
  clientListApi: string = ClientApi.list;
  userInfo: any;
  selectedClient: any;

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private loaderService: LoaderService,
    private quotationService: QuotationService,
    private userService: UserService,
    private sharedDataService: SharedDataService) {

  }

  ngOnInit() {
    this.quoteForm = this.fb.group(new QuotationForm(this.quotation))
    this.deliverableForm = this.fb.group(new QuotationDeliverableForm(new QuotationDeliverable));
    this.deliverables = this.quoteForm.get('items') as FormArray;
    if (this.quotation.quotation_date) {
      let invoiceDate = moment(this.quotation.quotation_date).format('DD-MM-YYYY')
      this.quoteForm.get('quotation_date').setValue(invoiceDate);
    }

    // Show/Hide whatsapp action as per pro plan
    this.sharedDataService.asObservable().subscribe((data) => {
      if (data && data.userInfo) {
        this.userInfo = data.userInfo;
      }
    })

    this.selectedClient = {
      id: this.quotation.client_id,
      full_name: this.quotation.client_name,
      email: this.quotation.client_email
    }
  }

  isProPlan() {
    return this.userInfo && this.userInfo.subscription && this.userInfo.subscription.subscription_plan == PLAN_TYPES.pro;
  }

  get totalAmount() {
    let items = this.deliverables ? this.deliverables.value : [];
    if (items && items.length > 0) {
      return items.reduce((a, b) => a + this.deliverableCost(b), 0);
    }
    return 0;
  }

  get prefTextColor() {
    return `${this.userInfo.preference.text_color} !important;`;
  }

  changeDiscount(value: number) {

    this.quotation.discount = value;
    this.calculateOriginalAmount();
    this.calculateDiscountedAmount();
  }

  calculateOriginalAmount() {
    this.quoteForm.get('original_amount').setValue(this.newQuoteOriginalAmount);
  }

  calculateDiscountedAmount() {
    this.quoteForm.get('discounted_amount').setValue(this.newQuoteDiscountAmount);
  }

  get quotationOriginalAmount() {

    if (this.quoteForm.get('discount').value > 0) {
      let items = this.deliverables ? this.deliverables.value : [];
      if (items && items.length > 0) {
        return items.reduce((a, b) => a + this.deliverableCost(b), 0);
      }
      return null;
    } else {
      return null;
    }
  }

  get quotationDiscountAmount() {
    if (this.quoteForm.get('discount').value > 0) {
      return (((this.quotationOriginalAmount) / (100) * (this.quoteForm.get('discount').value)));
    } else {
      return null;
    }
  }

  get quotationDeliveryFeeAmount() {
    if (this.quoteForm.get('delivery_fee').value > 0) {
      return Number(this.quoteForm.get('delivery_fee').value);
    } else {
      return 0;
    }
  }

  get quoteTotal() {
    // let items = this.deliverables ? this.deliverables.value : [];
    // if (items && items.length > 0) {
    //   return (items.reduce((a, b) => a + this.deliverableCost(b), 0)).toFixed(2);
    // }
    // return 0;
    if (this.quoteForm.get('discount').value > 0) {
      return ((this.quotationOriginalAmount) - (this.quotationDiscountAmount) + (this.quotationDeliveryFeeAmount));
    } else {
      let items = this.deliverables ? this.deliverables.value : [];
      if (items && items.length > 0) {
        return (items.reduce((a, b) => a + this.deliverableCost(b), 0)) + (this.quotationDeliveryFeeAmount);
      }
      return 0;
    }
  }

  get taxAmount() {
    let items = this.deliverables ? this.deliverables.value : [];
    if (items && items.length > 0) {
      return (items.reduce((a, b) => a + this.deliverableTax(b), 0)).toFixed(2);
    }
    return 0;
  }

  deliverableTax(deliverable: any) {
    const quoteFormValues = this.quoteForm.value;
    if (quoteFormValues.tax_type == 2) {
      return (quoteFormValues.include_tax && quoteFormValues.tax_percent && deliverable.is_taxable) ? (((deliverable.quantity * deliverable.rate) / (1 + quoteFormValues.tax_percent / 100)) * (quoteFormValues.tax_percent / 100)) : 0;
    } else if (quoteFormValues.tax_type == 3) {
      return 0;
    }
    return (quoteFormValues.include_tax && quoteFormValues.tax_percent && deliverable.is_taxable) ? (deliverable.quantity * deliverable.rate * quoteFormValues.tax_percent / 100) : 0;
  }

  get subTotal() {
    if (this.totalAmount) {

      let taxPercent = 0;
      if (this.quoteForm.get('include_tax').value)
        taxPercent = this.quoteForm.get('tax_percent').value;

      return taxPercent ? (this.totalAmount + this.totalAmount * taxPercent / 100) : this.totalAmount;
    }

    return 0;
  }

  onChangeClient(value: any) {
    if (value) {
      this.selectedClient = {
        id: value.id,
        full_name: value.full_name,
        email: value.email
      }
    }
  }

  getItemSubTotal(deliverableValues: any) {
    let value = deliverableValues.quantity * deliverableValues.rate;
    const quoteFormValues = this.quoteForm.value;
    if (!isNaN(value)) {
      if (quoteFormValues.tax_type == 2) {
        return ((deliverableValues.quantity * deliverableValues.rate)) / (1 + (quoteFormValues.tax_percent / 100));
      } else {
        return deliverableValues.quantity * deliverableValues.rate;
      }
    }
    return 0;
  }

  deliverableCost(deliverableValues: any) {
    let value = deliverableValues.quantity * deliverableValues.rate;

    const quoteFormValues = this.quoteForm.value;
    if (!isNaN(value)) {
      if (quoteFormValues.include_tax && quoteFormValues.tax_percent && deliverableValues.is_taxable) {
        value = value + value * quoteFormValues.tax_percent / 100;
      }
      return value;
    }
    return 0;
  }

  // new updates

  newDeliverableCost(deliverableValues: any) {
    let value = deliverableValues.quantity * deliverableValues.rate;
    if (!isNaN(value)) {
      return value;
    }
    return 0;
  }

  get newDeliverableTax() {
    const quoteFormValues = this.quoteForm.value;
    if (quoteFormValues.include_tax && quoteFormValues.tax_percent) {
      if (quoteFormValues.tax_type == 1) {
        return (this.newQuoteOriginalAmount * quoteFormValues.tax_percent / 100);
      } else if (quoteFormValues.tax_type == 2) {
        return (((this.newQuoteOriginalAmount) / (1 + quoteFormValues.tax_percent / 100)) * (quoteFormValues.tax_percent / 100))
      }
    }
    return 0;
  }

  get newSubTotalDeliverableCost(){
    let items = this.deliverables ? this.deliverables.value : [];
    if (items && items.length > 0) {
      return items.reduce((a, b) => a + this.newDeliverableCost(b), 0);
    }
    return 0;
  }

  get newQuoteDiscountAmount() {
    let discountAmount = this.quoteForm.get('discount').value;
    discountAmount = parseFloat(discountAmount).toFixed(2);
    if (discountAmount > 0) {
      // if (this.discountType != 'percentage') {
      //   return discountAmount;
      // }
      return (((this.newSubTotalDeliverableCost) / (100) * (discountAmount)));
    }
    return 0;
  }

  get newQuoteDeliveryFeeAmount() {
    if (this.quoteForm.get('delivery_fee').value > 0) {
      return this.quoteForm.get('delivery_fee').value;
    }
    return 0;
  }

  get newQuoteOriginalAmount() {
    return (this.newSubTotalDeliverableCost - this.newQuoteDiscountAmount);
  }

  get newTaxAmount() {
    let items = this.deliverables ? this.deliverables.value : [];
    if (items && items.length > 0) {
      return items.reduce((a, b) => a + this.deliverableTax(b), 0);
    }
    return 0;
  }

  get newQuoteTotal() {
    let value = this.newQuoteOriginalAmount;
    const quoteFormValues = this.quoteForm.value;
    if (quoteFormValues.include_tax && quoteFormValues.tax_percent) {
      if (quoteFormValues.tax_type == 3 || quoteFormValues.tax_type == 2) {
        value = value;
      // } else if (quoteFormValues.tax_type == 2) {
      //   value = value - (((value) / (1 + quoteFormValues.tax_percent / 100)) * (quoteFormValues.tax_percent / 100));
      } else {
        value = value + (value * quoteFormValues.tax_percent / 100);
      }      
    }
    return parseFloat(value + this.newQuoteDeliveryFeeAmount).toFixed(2);
  }
  
  // new updates end

  addDeliverable(form: FormGroup) {
    form.get('submitted').setValue('true');

    if (form.valid) {
      const currentDeliverbles = this.quoteForm.get('items') as FormArray
      currentDeliverbles.push(
        this.fb.group(
          new QuotationDeliverableForm(new QuotationDeliverable(form.value))
        )
      )

      form.reset({});

      this.deliverables = this.quoteForm.get('items') as FormArray;
      document.getElementById('create-deliverable').querySelector('input').focus();
    }
  }

  // addDeliverable(form: FormGroup) {
  //   const currentDeliverbles = this.quoteForm.get('items') as FormArray
  //   currentDeliverbles.push(
  //     this.fb.group(
  //       new QuotationDeliverableForm(new QuotationDeliverable(form.value))
  //     )
  //   )

  //   this.deliverables = this.quoteForm.get('items') as FormArray;
  //   document.getElementById('create-deliverable').querySelector('input').focus();
  // }

  removeDeliverable(index: number) {
    const currentDeliverbles = this.quoteForm.get('items') as FormArray

    currentDeliverbles.removeAt(index)
    this.deliverables = currentDeliverbles;
  }

  updateDeliverable(form: FormGroup) {
    form.controls.edit.setValue(false)
  }

  cancelEdit(form: FormGroup) {
    form.controls.edit.setValue(false);
  }

  enableTax(value: boolean) {
    let taxPercentControl = this.quoteForm.get('tax_percent');
    if (value) {
      taxPercentControl.setValidators([Validators.required]);
    } else {
      taxPercentControl.setValue(null);
      taxPercentControl.clearValidators();
    }
    taxPercentControl.updateValueAndValidity();
  }

  validate() {
    let deliverables = this.quoteForm.get('items').value;
    if (deliverables.length == 0) {
      Swal.fire({
        title: i18n.warning,
        text: i18n.quote.please_add_deliverable,
        icon: 'warning'
      })
    } else {
      this.submitted = true;

      if (this.quoteForm.valid) {
        return true
      }
    }

    return false;
  }

  saveAsDraft() {
    if (this.validate()) {
      this.quoteForm.get('is_draft').setValue(1);
      this.quoteForm.get('action').setValue('draft');
      this.submit();
    }
  }

  async saveAsPdf() {
    if (this.validate()) {
      try {
        this.quoteForm.get('is_draft').setValue(0);
        let data: any = await this.submit();

        (window as any).open(`${environment.baseUrl}/download/quotation/${data.uuid}/pdf?lang=${(window as any).LOCALE}`, '_self', 'location=yes');
      } catch (err) {
        console.error('promise error')
      }
    }
  }

  saveAndEmail() {
    if (this.validate()) {
      this.quoteForm.get('is_draft').setValue(0);
      this.quoteForm.get('action').setValue(QUOTE_ACTIONS.EMAIL);
      this.submit();
    }
  }

  saveAndWhatsapp() {
    if (this.validate()) {
      this.quoteForm.get('is_draft').setValue(0);
      this.quoteForm.get('action').setValue(QUOTE_ACTIONS.WHATSAPP);
      this.submit();
    }
  }

  saveQuote() {
    if (this.validate()) {
      this.quoteForm.get('is_draft').setValue(0);
      this.quoteForm.get('action').setValue(null);
      this.submit();
    }
  }

  private submit() {

    return new Promise((resolve, reject) => {
      this.loaderService.startLoading();

      let fd: any = this.quoteForm.value;
      fd.uuid = this.quotation.uuid;
      fd.quotation_date = parseDate(fd.quotation_date);

      fd.total_amount = this.totalAmount;
      fd.sub_total = this.subTotal;
      if(this.quotation.status == 'rejected'){
        fd.status = 'pending';
      }

      //To=Do - rename items to deliverables
      fd.deliverables = fd.items;
      delete fd.items;

      // Create Quotation
      this.quotationService.update(fd).subscribe((r) => {
        this.loaderService.stopLoading();

        let msg = i18n.quote.quote_saved;

        if (fd.action == QUOTE_ACTIONS.WHATSAPP) {
          msg = i18n.quote.quote_saved_and_whatsapp;
        } else if (fd.action == QUOTE_ACTIONS.EMAIL) {
          msg = i18n.quote.quote_saved_and_email;
        }

        Swal.fire(i18n.done, msg, 'success').then(() => {
          this.quoteForm = this.fb.group(new QuotationForm(new Quotation()))
          this.deliverables = this.quoteForm.get('items') as FormArray;

          this.onEdit.emit(fd.action);
        });
        this.submitted = false;
        resolve(r);
      }, (err) => {
        this.loaderService.stopLoading();

        // Set server side error
        if (err.status === 422) {
          if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
            let validationErrors = err.error.errors;

            Object.keys(validationErrors).forEach((prop) => {
              this.quoteForm.get(prop)?.setErrors({
                serverError: validationErrors[prop]
              })
            })
          }
        }

        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');

        // reject(err);
      })
    });
  }

  // openAddPaymentInfoModal(){
  //   let paymentInfo = this.quoteForm.get('payment_info').value;
  //   if(!paymentInfo || !paymentInfo.name) {
  //     paymentInfo = this.defaultPaymentInfo
  //   }

  //   const modalRef = this.modalService.open(PaymentInfoModalComponent);
  //   modalRef.componentInstance.paymentInfo =  paymentInfo;

  //   modalRef.result.then(result => {
  //     this.quoteForm.get('include_payment_info').setValue(true);
  //     this.quoteForm.get('payment_info').setValue(result.formData);
  //     this.quoteForm.get('save_default_payment_info').setValue(result.submit_type == "default");
  //   }, fallbackResult => {
  //     // do nothing
  //   })
  // }

}
